import debug from 'debug';

const log = debug('InspirationProductsByCategory:Utils:Facets');

class Facets {
	/**
	 * @param {Object} options
	 * @param {string} [options.categories]
	 * @param {boolean} [options.excludeBorderShops]
	 * @param {number} [options.numberOfResults]
	 * 
	 * @returns {string} facet querystrings
	 */
	static get({ categories, excludeBorderShops, numberOfResults }) {
		let facets = '';

		if (categories !== undefined) {
			facets += `categories=${categories}`;
		}

		if (numberOfResults !== undefined && numberOfResults > 0) {
			facets += `&numberOfResults=${numberOfResults}`;
		}

		if (excludeBorderShops) {
			facets += `&catalogCategoriesToExclude=Grænsebutikker`;
		}

		return facets;
	}
}

export default Facets;
